import {Component, OnInit} from '@angular/core';
import {GetSetDataService} from '../../services/get-set-data.service';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [
    RouterLink
  ],
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(private getSet: GetSetDataService) {
  }

  scrollToTop() {
    this.getSet.scrollToTop();
  }
}
